import { useState } from 'react';
import WarehouseCommonApi from '../../../../../../API/warehouse/common-api';
import minus from '../../../../../../assets/media/icons/minus.svg';
import plus from '../../../../../../assets/media/icons/plus.svg';
import { Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../../components/Basic/Elements';
import { Input } from '../../../../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../../../../constans';

const ReserveStepper = ({ item = {}, save = () => { }, skladName, ...props }) => {

  const [value, setValue] = useState(0);

  const onChange = async (id, value) => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId: id, field: 'hand_reserve', value, skladName } })
      .then((r) => {
        setValue(0);
        save(r.warehouseProduct);
      })
      .catch();
  };

  const clickAdd = async () => {
    if (value > 0) {
      await onChange(item.id, value);
    }
  };

  const clickDebit = async () => {
    if (value > 0) {
      await onChange(item.id, 0 - value); // передаем отрицательное число
    }
  };

  const reserved = item.sklad_data?.[skladName].shipment_reserved + item.sklad_data?.[skladName].hand_reserved;

  return (
    <Row>
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginRight: '10px' }}
        disabled={value > item.sklad_data?.[skladName].hand_reserved}
        onClick={clickDebit}
      >
        <Icon src={minus} width="16px" />
      </Button>
      <Input value={value} onChange={(v) => setValue(v)} style={{ width: '30px' }} center />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginLeft: '10px' }}
        disabled={parseInt(value, 10) + reserved > item.stock || value === 0}
        onClick={clickAdd}
      >
        <Icon src={plus} width="15px" />
      </Button>
    </Row>
  );
};

export default ReserveStepper;
